module.exports = __webpack_public_path__ + "img/landing-conversions-with.e90f28c.png";